import { render } from "./ListaTextos.vue?vue&type=template&id=5a481942&scoped=true&ts=true"
import script from "./ListaTextos.vue?vue&type=script&lang=ts"
export * from "./ListaTextos.vue?vue&type=script&lang=ts"

import "./ListaTextos.vue?vue&type=style&index=0&id=5a481942&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a481942"]])

export default __exports__